import { useRef, useState } from 'react';
import '../Components/birthday.css'
import { useNotification } from '../Components/NoticeHandler';

function CreateBirthdayCard() {
    const nameInputRef = useRef(null);
    const genderInputRef = useRef(null);
    const messageInputRef = useRef(null);
    const notify = useNotification();
    const [ birthdayurl, SetBirthdayURL ] = useState(window.location.origin + "/birthday")
    const GenerateBirthdayURL = () => {
        var urlgender = 'person'
        var urlparams = ''
        if (genderInputRef.current.value === "boy" || genderInputRef.current.value === "girl") {
            urlgender = genderInputRef.current.value;
        }
        if (nameInputRef.current.value !== null) {
            if (nameInputRef.current.value.length > 0) {
                urlparams = "?birthday" + urlgender + '=' + encodeURIComponent(nameInputRef.current.value);
            }
        }
        if (messageInputRef.current.value !== null) {
            if (messageInputRef.current.value.length > 0) {
                if (urlparams.length <= 0) {
                    urlparams += '?';
                }
                else {
                    urlparams += '&';
                }
                urlparams += "birthdaymessage=" + messageInputRef.current.value;
            }
        }
        SetBirthdayURL(window.location.origin + "/birthday" + urlparams)
    }
    const handlekeydownSubmit = (event) => {
        if (event.key === "Enter") {
            GenerateBirthdayURL();
        }
    }
    const birthdayMessages = [
    {
        name: "WarmJoyful",
        message: "Happy Birthday! Wishing you a wonderful day filled with love, laughter, and joy."
    },
    {
        name: "SimpleSweet",
        message: "Happy Birthday! Hope your day is as amazing as you are."
    },
    {
        name: "ProfessionalPolite",
        message: "Happy Birthday! May this year bring you happiness and success."
    },
    {
        name: "CakeReminder",
        message: "Happy Birthday! Don’t forget to treat yourself to lots of cake today."
    },
    {
        name: "CheersAdventure",
        message: "Happy Birthday! Cheers to another year of adventures and memories."
    },
    {
        name: "FunLight",
        message: "Happy Birthday! Wishing you a day full of fun, laughter, and celebration!"
    },
    {
        name: "FunnyLevelUp",
        message: "Happy Birthday! You’re not getting older, you’re just leveling up!"
    },
    {
        name: "HealthHappiness",
        message: "Happy Birthday! May your year be filled with health, wealth, and happiness."
    },
    {
        name: "WarmWishes",
        message: "Happy Birthday! Sending you good vibes and warm wishes on your special day."
    },
    {
        name: "BrightFuture",
        message: "Happy Birthday! Hope today is just the start of a fantastic year ahead."
    }
    ];
    async function CopyURLtoClipboard() {
        try {
            await navigator.clipboard.writeText(birthdayurl);
            console.log('Text copied to clipboard successfully!');
            notify("Text Copied!", "Text was copied sucessfully", "Success");
        } catch (err) {
            console.error('Failed to copy text: ', err);
            notify("Error when Copying Text", "Text failed to copy", "Error");
        }
    }

    return (
        <>
            <div className='CenterPage'>
                    <h1>Create a Birthday Card!</h1>
                    <p>Enter person's name and Gender!</p>
                    <input
                        type='text'
                        ref={nameInputRef}
                        id='BirthdayName'
                        name='BirthdayPersonName'
                        placeholder='Name'
                        onSubmit={GenerateBirthdayURL}
                        onKeyDown={handlekeydownSubmit}
                    />
                    <br/>
                    <p>
                        <label>Gender:&emsp;</label>
                        <select
                        name="Gender" 
                        key='BirthdayGender'
                        ref={genderInputRef}
                        onChange={GenerateBirthdayURL}
                        onKeyDown={handlekeydownSubmit}>
                            <option value={''}>-- Select a Gender --</option>
                            <option value={"boy"}>Boy</option>
                            <option value={"girl"}>Girl</option>
                            <option value={"person"}>Other</option>
                        </select><br/> <br/>
                        <select
                        name="BirthdayMessage"
                        key='BirthdayMessageInput'
                        ref={messageInputRef}
                        onChange={GenerateBirthdayURL}
                        onKeyDown={handlekeydownSubmit}
                        >
                            <option value={''}>-- Choose a Message --</option>
                            {
                                birthdayMessages.map((msg, index) => (
                                    <option value={msg.name}>
                                        {msg.message}
                                    </option>
                                ))
                            }
                        </select>
                    </p>
                    <button type='submit' onClick={GenerateBirthdayURL}>Generate URL</button>
                <br/><br/>
                <a href={birthdayurl}><code>{birthdayurl}</code></a><br/><br/>
                <button onClick={CopyURLtoClipboard}>Copy to Clipboard</button>
            </div>
        </>
    );
}

export default CreateBirthdayCard